import { COLOR_KEYS_LIST } from '../../../constants';
import { createBuilderModule } from '../../../builder';
import { SectionName, withTracking } from '../../../observability';
import { ExploreSection } from './ExploreSection';
import { withChildren } from '@builder.io/react';

export default createBuilderModule(
  withChildren(
    withTracking(ExploreSection, { sectionName: SectionName.ExploreSection }),
  ),
  {
    name: 'ExploreSection',
    image: 'https://cdn.zappy.app/4f499a9284bcf444d098c2e78157b8e7.png',
    inputs: [
      { name: 'heading', type: 'string', required: true },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: ['', ...COLOR_KEYS_LIST],
      },
      {
        name: 'image',
        type: 'object',
        subFields: [
          { name: 'altText', type: 'string', required: true },
          { name: 'url', type: 'string', required: true },
        ],
      },

      {
        name: 'links',
        type: 'list',
        subFields: [
          { name: 'text', type: 'string', required: true },
          { name: 'url', type: 'string', required: true },
        ],
      },
    ],
  },
);
